import React from 'react';
import '../../styles/common.css';
import styles from './About.module.css';

// Hero section
const HeroSection = () => (
  <header id="about" className={styles.hero}>
    <div className={styles.heroInner}>
      <h1 className="title">InterWorld</h1>
      <p className="lead">
        InterWorld — это сервер по игре Hytale, созданный простыми игроками для таких же игроков. Мы стремимся обеспечить максимально приятный и увлекательный игровой процесс в тёплой и дружелюбной атмосфере.
      </p>
      <a href="/getting-started" className="btnPrimaryCustom" style={{marginTop: '1rem'}}>
        Начать играть
      </a>
    </div>
  </header>
);

// Mission section
const MissionSection = () => (
  <section className={`glassCard ${styles.section}`}>
    <h2 className="title">Наша миссия</h2>
    <p>
      Наша миссия — создавать честный и увлекательный игровой опыт: стабильный сервер, интересные режимы и регулярные ивенты. Мы строим сообщество, где участники помогают друг другу и вместе развивают проект.
    </p>
  </section>
);

// Offerings section with cards
const OfferingsSection = () => (
  <section className={`glassCard ${styles.section}`}>
    <h2 className="title">Что мы предлагаем</h2>
    <div className={styles.grid}>
      <div className={styles.card}>
        <h3>События и ивенты</h3>
        <p>
          Регулярные обновления, мероприятия и внутриигровые активности — всё, чтобы играть было интересно.
        </p>
      </div>
      <div className={styles.card}>
        <h3>Поддержка игроков</h3>
        <p>
          Активная команда модераторов и канал поддержки по вопросам доступа, проблем с аккаунтом и спорных ситуаций.
        </p>
      </div>
      <div className={styles.card}>
        <h3>Творческие режимы</h3>
        <p>
          Уникальные игровые режимы и моды, которые мы создаём и поддерживаем сами — от новых механик до контента для событий.
        </p>
      </div>
    </div>
  </section>
);

// Team section
const TeamSection = () => (
  <section className={`glassCard ${styles.section}`}>
    <h2 className="title">Команда</h2>
    <p>
      Наша команда — небольшая группа волонтёров: девелоперы, модераторы и организаторы. Мы открыты к новым участникам и вкладчикам.
    </p>
  </section>
);

// Support section
const SupportSection = () => (
  <section className={`glassCard ${styles.section}`}>
    <p>
      Проект создаётся игроками, поэтому нам важна ваша помощь: финансовая поддержка и волонтёрский вклад (тестирование, моддинг, проведение ивентов). Если можете чемто помочь или хотите о чём-то спросить — свяжитесь с нами любым способом через{' '}
      <a href="/contacts">страницу контактов</a>
    </p>
  </section>
);

// Main component
const About = () => {
  return (
    <main className={`container ${styles.about}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <HeroSection />
          <MissionSection />
          <OfferingsSection />
          <TeamSection />
          <SupportSection />
        </div>
      </div>
    </main>
  );
};

export default About;
